import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useWallet } from '../../../context/WalletContext';
import { ArrowLeftIcon } from '../../../assets/icons';
import { shortenAddress } from '../../../utils/formatters';
import logo from '../../../assets/logo-mark.png';
import './Header.css';

const Header = ({ title, showBack = false, showLogo = true }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { account, isConnected } = useWallet();

  const handleBack = () => {
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigate('/dashboard');
    }
  };

  const isHome = location.pathname === '/' || location.pathname === '/dashboard';

  return (
    <header className="header">
      <div className="header-left">
        {showBack && !isHome ? (
          <button className="header-back" onClick={handleBack}>
            <ArrowLeftIcon size={24} />
          </button>
        ) : showLogo ? (
          <div className="header-logo" onClick={() => navigate('/dashboard')}>
            <img src={logo} alt="Gainforce" className="header-logo-img" />
            <span className="header-logo-text">Gainforce</span>
          </div>
        ) : null}
      </div>
      
      <div className="header-center">
        {title && <h1 className="header-title">{title}</h1>}
      </div>
      
      <div className="header-right">
        {isConnected && (
          <div className="header-wallet">
            <span className="header-wallet-dot" />
            <span className="header-wallet-address">
              {shortenAddress(account, 3)}
            </span>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
